// BuyerQuest Logger
//
// Log while in debug mode / not in production

bq.debugState = (document.URL.toLowerCase().indexOf("jsdebug=true") >= 0);

if (bq.debugState) {

  try {
    bq.debug = {
      log: window.console.log.bind(window.console, '%s'),
      error: window.console.error.bind(window.console, 'error: %s'),
      info: window.console.info.bind(window.console, 'info: %s'),
      warn: window.console.warn.bind(window.console, 'warn: %s')
    };
  } catch(e) {

    bq.debug = {
      log: function(a){window.console.log(a);},
      error: function(a){window.console.log(a);},
      info: function(a){window.console.log(a);},
      warn: function(a){window.console.log(a);}
    };
  }
} else {
  var __no_op = function() {};

  bq.debug = {
    log: __no_op,
    error: __no_op,
    warn: __no_op,
    info: __no_op
  };
}